var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.componentData)?_c('div',{attrs:{"data-app":""}},[_c('HomeRootComponent',{attrs:{"parent-component-data":_vm.getComponentData}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }